<template>
  <v-card class="mb-5">
    <div class="pl-5 pr-5">
      <v-row>
        <v-col><span class="font-italic label-day" style="font-size:1.1rem">{{ moment(item.testDateTime, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm')  }}</span></v-col>
        <!-- <v-col><span class="font-italic label-day" style="color:red"> Weight </span>
          <span class="font-italic label-day"  style="font-size:1.2rem"> {{ item.weight }} </span>KG</v-col> -->
        <v-col class="text-right">
          <span class="font-italic " style="color:red"> Weight </span>
          <span class="font-italic label-black "  style="font-size:1.5rem"> {{ item.weight }} </span><span>KG</span>
          <v-icon
            @click="handleClick()"
          >
            mdi-chevron-double-right
          </v-icon>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <!-- <v-col><span class="font-weight-thin mt-5 label-attendance" >{{ formatDate(item.courseDate) }}</span></v-col> -->
<v-col></v-col>
        <v-col>
          <span class="font-weight-black " style="color:#12CDD4">Weight Control</span>
          </v-col>
          <v-col>
            <span class="font-weight-black " style="color:#F35233">Fat Control</span>
            </v-col>
            <v-col>
              <span class="font-weight-black " style="color:#571F1F">Muscle Control</span>
              </v-col>
  
      </v-row>
      <v-row>
        <v-col class="mt-0">
          <span class="font-italic label-black "  style="font-size:1rem; ">{{ item.inBodyScore }}</span> 
            <span class="font-italic label-black"> / 100 Points</span>
        </v-col>
            <v-col>
              <span class="font-italic label-black "  style="font-size:1rem; ">{{ item.weightControl }}
                <span class="label-small"> Kg</span></span> 
            </v-col>
            <v-col>
              <span class="font-italic label-black "  style="font-size:1rem; ">{{ item.bfmControl }}
                <span class="label-small"> Kg</span></span> 
            </v-col>
            <v-col>
              <span class="font-italic label-black "  style="font-size:1rem; ">{{ item.ffmControl }}
                <span class="label-small"> Kg</span></span> 
            </v-col>
      </v-row>
    </div>
  </v-card>
</template>
<script setup>
import { ref, toRefs } from 'vue'
import { formatTime, formatDate, loading } from '@/utils/helper'
import moment from '@/utils/moment'

const prop = defineProps({
  item: {
    type: Object,
    default: () => ({
      id: 1,
      day: 48,
      dailyEvaluation: '加強外側肌肉(大腿)',
      attendanceDate: '12/07/2022',
      bodyWeight: 83.5,
      caloriesExpended: 2130,
    }),
  },
})
const { item } = toRefs(prop)
const emits = defineEmits(['click'])
function handleClick() {
  console.log('click')
  emits('click', item)
}
</script>
<style scoped>
.label-day{
  color:blue;
}

.label-black{
  color:black;
}

.value-weight{
  font-size: 20px;
}
.label-small{
  font-size: 9px;
}
.label-attendance{
  line-height: 2rem;
}
</style>
